// ── Editor tab code-split chunks ───────────────────────────────────────────
// Every workflow-editor tab is a React.lazy route, and the only Suspense
// boundary above them is MainLayout's — which sits ABOVE <Editor>. React 19
// keeps an already-mounted boundary's previous children on screen for the
// duration of a transition rather than showing its fallback, and react-router
// v7 runs navigations in a transition. So on the first click of a tab, nothing
// moves — not the panel, not even the tab highlight — until that tab's chunk
// has finished downloading.
//
// This map is the single source of truth for those import specifiers: App.js
// builds its React.lazy components from it, and TopNavBar warms the same
// chunk on hover/focus so the download is off the click's critical path.
// Keeping ONE specifier per chunk is what guarantees the warm-up and the
// lazy() resolve to the same webpack chunk.
export const EDITOR_TAB_CHUNKS = {
  overview: () => import("./OverviewPanel"),
  diagram: () => import("./DiagramView"),
  global: () => import("../GlobalVariablesPanel"),
  activities: () => import("../activities/ActivitiesManager"),
  "activity-form": () => import("../activities/ActivityFormManager"),
  knowledge: () => import("./WorkflowKnowledgePanel"),
  api: () => import("../ApiDocsPanel"),
  config: () => import("../ConfigPanel"),
};

// Warm one tab's chunk. Safe to call repeatedly — webpack caches the module
// after the first import(), so later calls are a no-op. A failed prefetch is
// swallowed: the real navigation will surface the error through Suspense.
const warmed = new Set();
export const prefetchEditorTab = (tabId) => {
  if (warmed.has(tabId)) return;
  const load = EDITOR_TAB_CHUNKS[tabId];
  if (!load) return;
  warmed.add(tabId);
  load().catch(() => warmed.delete(tabId));
};
